// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutAboutRouteImport } from './routes/_layout/about'
import { Route as LayoutCartRouteImport } from './routes/_layout/cart'
import { Route as LayoutContactRouteImport } from './routes/_layout/contact'
import { Route as LayoutFaqRouteImport } from './routes/_layout/faq'
import { Route as LayoutFavouritesRouteImport } from './routes/_layout/favourites'
import { Route as LayoutGiveawayRouteImport } from './routes/_layout/giveaway'
import { Route as LayoutProductsRouteImport } from './routes/_layout/products'
import { Route as LayoutReviewSuccessRouteImport } from './routes/_layout/review-success'
import { Route as LayoutCollectionsHandleRouteImport } from './routes/_layout/_collections.$handle'
import { Route as LayoutLegalCookiePolicyRouteImport } from './routes/_layout/legal.cookie-policy'
import { Route as LayoutLegalImprintRouteImport } from './routes/_layout/legal.imprint'
import { Route as LayoutLegalPrivacyPolicyRouteImport } from './routes/_layout/legal.privacy-policy'
import { Route as LayoutLegalTermsOfServiceRouteImport } from './routes/_layout/legal.terms-of-service'
import { Route as LayoutProductHandleRouteImport } from './routes/_layout/product.$handle'

const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          })
const LayoutIndexRoute = LayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutRoute
          })
const LayoutAboutRoute = LayoutAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LayoutRoute
          })
const LayoutCartRoute = LayoutCartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => LayoutRoute
          })
const LayoutContactRoute = LayoutContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LayoutRoute
          })
const LayoutFaqRoute = LayoutFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => LayoutRoute
          })
const LayoutFavouritesRoute = LayoutFavouritesRouteImport.update({
            id: '/favourites',path: '/favourites',getParentRoute: () => LayoutRoute
          })
const LayoutGiveawayRoute = LayoutGiveawayRouteImport.update({
            id: '/giveaway',path: '/giveaway',getParentRoute: () => LayoutRoute
          })
const LayoutProductsRoute = LayoutProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => LayoutRoute
          })
const LayoutReviewSuccessRoute = LayoutReviewSuccessRouteImport.update({
            id: '/review-success',path: '/review-success',getParentRoute: () => LayoutRoute
          })
const LayoutCollectionsHandleRoute = LayoutCollectionsHandleRouteImport.update({
            id: '/_collections/$handle',path: '/$handle',getParentRoute: () => LayoutRoute
          })
const LayoutLegalCookiePolicyRoute = LayoutLegalCookiePolicyRouteImport.update({
            id: '/legal/cookie-policy',path: '/legal/cookie-policy',getParentRoute: () => LayoutRoute
          })
const LayoutLegalImprintRoute = LayoutLegalImprintRouteImport.update({
            id: '/legal/imprint',path: '/legal/imprint',getParentRoute: () => LayoutRoute
          })
const LayoutLegalPrivacyPolicyRoute = LayoutLegalPrivacyPolicyRouteImport.update({
            id: '/legal/privacy-policy',path: '/legal/privacy-policy',getParentRoute: () => LayoutRoute
          })
const LayoutLegalTermsOfServiceRoute = LayoutLegalTermsOfServiceRouteImport.update({
            id: '/legal/terms-of-service',path: '/legal/terms-of-service',getParentRoute: () => LayoutRoute
          })
const LayoutProductHandleRoute = LayoutProductHandleRouteImport.update({
            id: '/product/$handle',path: '/product/$handle',getParentRoute: () => LayoutRoute
          })





const LayoutRouteChildren = {
  LayoutAboutRoute: LayoutAboutRoute,LayoutCartRoute: LayoutCartRoute,LayoutContactRoute: LayoutContactRoute,LayoutFaqRoute: LayoutFaqRoute,LayoutFavouritesRoute: LayoutFavouritesRoute,LayoutGiveawayRoute: LayoutGiveawayRoute,LayoutProductsRoute: LayoutProductsRoute,LayoutReviewSuccessRoute: LayoutReviewSuccessRoute,LayoutIndexRoute: LayoutIndexRoute,LayoutCollectionsHandleRoute: LayoutCollectionsHandleRoute,LayoutLegalCookiePolicyRoute: LayoutLegalCookiePolicyRoute,LayoutLegalImprintRoute: LayoutLegalImprintRoute,LayoutLegalPrivacyPolicyRoute: LayoutLegalPrivacyPolicyRoute,LayoutLegalTermsOfServiceRoute: LayoutLegalTermsOfServiceRoute,LayoutProductHandleRoute: LayoutProductHandleRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)